import { MARQUEE_PHRASES } from "@/data/site";

export default function Marquee() {
  const row = [...MARQUEE_PHRASES, ...MARQUEE_PHRASES];
  return (
    <div className="relative overflow-hidden border-b border-steel bg-carbon py-5" data-testid="kinetic-marquee" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {row.map((p, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className={`font-heading font-black uppercase text-3xl sm:text-4xl tracking-tight px-6 ${i % 2 === 0 ? "text-stroke-thin" : "text-white/90"}`}>
              {p}
            </span>
            <span className="w-3 h-3 bg-hazard rotate-45 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
